import { EmurseAppFactory, EmurseAppRegistration, EmurseStartup, type IAppData } from '@/EmurseStartup';
import ContactApp from './Contact.vue';
import { FormRepository } from '@/data/repository/FormRepository';
 
EmurseAppFactory.registerApp(new EmurseAppRegistration("contact",(appData: IAppData)=>
{ 
  const startupData= {app: ContactApp,
    appData:appData,
    repositories:{
      formRepository: FormRepository
    }}; 
  const startup = new EmurseStartup(startupData);
}));  